import { Box, Typography } from "@mui/material";
import { StudyIcon } from "../AllStudies/StudyIcon";
import { Study } from "../models";

interface StudyHeaderProps {
  study?: Study;
}

export default function StudyHeader({ study }: StudyHeaderProps) {
  return !study ? (
    <></>
  ) : (
    <Box sx={{ display: "flex", gap: "5px", alignItems: "center" }}>
      <StudyIcon therapeuticArea={study.therapeutic_area.therapeutic_area_name} size={32} />
      <Typography variant="h5" sx={{ color: "#004677" }}>
        {study?.study_name ?? ""}
      </Typography>
    </Box>
  );
}
